import { makeStyles } from '@material-ui/core';
import { rgba } from 'polished';

export const useStyles = makeStyles(theme => ({
  container: {
    borderBottomRightRadius: 32,
    zIndex: theme.zIndex.drawer + 1,
    minWidth: 232,
  },
  blank: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: 0,
    height: '60px',
    backgroundColor: theme.palette.secondary.light,
    borderTopRightRadius: 16,
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: theme.palette.secondary.main,
    paddingLeft: 24,
    fontWeight: 'bold',
  },
  paper: {
    backgroundColor: theme.palette.secondary.main,
    borderBottomRightRadius: 16,
    borderTopRightRadius: 0,
    overflow: 'hidden',
  },
  menu: {
    '&.MuiList-padding': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  button: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    paddingTop: 18,
    paddingBottom: 18,
    color: theme.palette.common.white,
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.75,
    paddingLeft: 24,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.secondary.dark,
      width: '100%',
      borderRadius: 0,
    },
  },
  lastItem: {
    borderBottomRightRadius: 16,
  },
  active: {
    '&.MuiListItem-gutters': {
      paddingLeft: 14,
      paddingRight: 14,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.secondary.light,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.secondary.dark,
    },
    '& $icon': {
      color: theme.palette.secondary.dark,
    },
  },
  inactive: {
    '& span': {
      fontWeight: 500,
      color: rgba(255, 255, 255, 0.5),
    },
  },
  menuItem: {
    color: theme.palette.common.white,
    lineHeight: theme.typography.body1.lineHeight,
    fontSize: theme.typography.body1.fontSize,
    paddingTop: 14,
    paddingBottom: 14,
  },
  divider: {
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
}));
